import m from "mithril";
import FormUtilities from "../../../shared/utilities/form_utilities";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import ModalManager from "../../../shared/modal";
import Toasts from "../../../shared/toasts";
import i18n from "../../../shared/i18n/i18n";
import UniqueName from "../../../shared/uniqueName";
import RouterService from "../../../shared/services/router.service";

let saving = false;
let uploading = false;
let unit = {
    name: "",
    description: ""
};
let modalId;

function saveUnit() {
    if (FormUtilities.validateFields(".modal input")) {
        saving = true;
        Requester.post(Gateway.admin + "units/approval", unit)
            .then(function (result) {
                saving = false;
                ModalManager.close(modalId);
                RouterService.navigateToUnit(result);
            }).catch(function (error) {
            saving = false;
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
    }
}

function isUnitNameUniqueNotUnitLoading(uniqueName){
    return ((uniqueName.isUnitNameUnique) && !(uniqueName.unitLoading));
}

function isSaveBtnEnabled(){
    return !saving && !uploading && isUnitNameUniqueNotUnitLoading(UniqueName) && !!unit.instructions;
}

const Modal_Unit_Approval_New = {
    oninit: function() {
        unit = {
            name: "",
            description: ""
        };
    },
    view: function () {
        return [
            m(".form-section required", [
                m(".form-label", i18n.t("name")),
                m("input[type=text]", {
                    onchange: function () {
                        UniqueName.checkUniqueUnitName("new", this.value)
                    },
                    oninput: function () {
                        unit.name = this.value;
                    }, value: unit.name
                })
            ]),
            m(".form-section", [
                m(".form-label", i18n.t("description_not_visible_to_learners")),
                m("textarea", {
                    oninput: function () {
                        unit.description = this.value;
                    }, value: unit.description
                })
            ]),
            m(".form-section required", [
                m(".form-label", i18n.t("instructions_will_appear_for_learners")),
                m("textarea", {
                    oninput: function () {
                        unit.instructions = this.value;
                    }, value: unit.instructions
                })
            ]),
            m(".form-buttons", [
                isSaveBtnEnabled() ?
                    m("button", {onclick: saveUnit}, i18n.t("save")) :
                    (UniqueName.isUnitNameUnique) && !!unit.instructions ?
                        m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")]) :
                        m("button.btn-text no-click", [i18n.t("save")])
            ])
        ];
    },
    setModalId: function(id) {
        modalId = id;
    }
};
export default Modal_Unit_Approval_New;
